import React from 'react';

const TileShowcase = props => {
  return (
    <div>
      <div className='app-tile-showcase'>
        {props.data}
      </div>
    </div>
  )
}

export default TileShowcase



// WEBPACK FOOTER //
// ./src/components/dashboard/TileShowcase.js